import React from 'react';
import _ from 'lodash';
import { Box, Button, Card, CardContent, Checkbox, Stack, Typography, TextField } from '@mui/material';
import { useSelector } from 'react-redux';
import DocumentsButtons from './documents/DocumentsButtons';
import { DocumentCheckboxes } from './documents/DocumentCheckboxes';
import { WorkStandards } from './documents/WorkStandards';
import { AdditionalDocuments } from './documents/AdditionalDocuments';
import { EssentialDocuments } from './documents/EssentialDocuments';
import { EmailButton } from './documents/EmailButton';
import { PersonalDataProtectionDocuments } from './documents/PersonalDataProtectionDocuments';
import { OrganizingCampsInstructionDocuments } from './documents/OrganizingCampsInstructionDocuments';
import { TemplateDocuments } from './documents/TemplateDocuments';
import { useApplication } from '../../ApplicationsContext';

const PASSWORD = 'ssrekrutacjadocs';

export default function Documents({ formik }) {
  const { rowData } = useApplication();
  const seasonYear = rowData.season_year;
  const [password, setPassword] = React.useState('');
  const [authorized, setAuthorized] = React.useState(false);
  const currentYear = new Date().getFullYear();

  const handleCheckPassword = () => {
    if (password === PASSWORD) {
      setAuthorized(true);
    }
  };

  if (!authorized && seasonYear < currentYear) {
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ height: '100%' }}>
        <Card sx={{ width: 600 }}>
          <CardContent>
            <Stack spacing={2}>
              <Typography variant="h6">
                Wprowadź hasło
              </Typography>
              <Typography variant="">
                Dostęp do dokumentów z lat ubiegłych wymaga podania hasła
              </Typography>

              <TextField
                type="password"
                label="Hasło"
                value={password}
                onChange={e => setPassword(e.target.value)}
                fullWidth
              />

              <Button variant="contained" onClick={handleCheckPassword}>
                Zatwierdź
              </Button>
            </Stack>
          </CardContent>
        </Card>
      </Stack>
    );
  }

  return (
    <Stack>
      <Card style={{ height: '100%' }}>
        <CardContent>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} mb={2} flex="1 1 80%">
              <Typography variant="subtitle2" flex="1 1 75%">Alert - nowy dokument przesłany przez pracownika</Typography>
              <Box sx={{ flex: '1 1 99%' }}>
                <Checkbox
                  id="new_document_added_by_staff"
                  name="new_document_added_by_staff"
                  checked={formik.values.new_document_added_by_staff}
                  onChange={formik.handleChange}
                  disabled={!formik.values.new_document_added_by_staff}
                />
              </Box>
            </Stack>
            <EmailButton />
          </Stack>
          <DocumentCheckboxes formik={formik} />
          <WorkStandards />
          <PersonalDataProtectionDocuments />
          <OrganizingCampsInstructionDocuments />
          <EssentialDocuments />
          {[6, 14, 16].includes(formik.values.function_type) && <TemplateDocuments />}
          <AdditionalDocuments />
          <DocumentsButtons formik={formik} />
        </CardContent>
      </Card>
    </Stack>
  );
}
